import {
  TextField,
  Button,
  Box,
  MenuItem,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Grid,
  Card,
  CardContent,
  FormControl,
  Select,
} from "@mui/material";
import DialogPopup from "../PopupPropertiesMenu/QuizModule/DialogPopup";

import CustomDialog from "../PopupPropertiesMenu/CustomDialog";
export function Answer({
  qIndex,
  aIndex,
  answer,
  editState,
  handleInputChange,
  handleMediaUpdate,
  deleteAnswer,
  externalBookId,
  lang,
}) {
  return (
    <Box
      display="flex"
      gap="15px"
      alignItems="center"
      justifyContent="space-evenly"
      mb={1}
    >
      <FormControl component="fieldset" mt sx={{ mx: 0.5 }}>
        <FormControlLabel
          control={
            <Checkbox
              color="success"
              checked={answer.isCorrect}
              onChange={(e) =>
                handleInputChange(qIndex, aIndex, e.target.checked, "isCorrect")
              }
              disabled={!editState[`${qIndex}-null`]}
            />
          }
          label={answer.isCorrect ? "Correct" : "Incorrect"}
          labelPlacement="top"
        />
      </FormControl>
      <TextField
        fullWidth
        variant="outlined"
        value={answer.text[lang] || ""}
        onChange={(e) => handleInputChange(qIndex, aIndex, e.target.value)}
        disabled={!editState[`${qIndex}-null`]}
        style={{ marginRight: 10 }}
      />

      {editState[`${qIndex}-null`] && (
        <>
          <DialogPopup
            bookId={externalBookId}
            questionIndex={qIndex}
            answerIndex={aIndex}
            disabled={!editState[`${qIndex}-null`]}
            media={answer?.media?.filter((m) => m.language === lang)[0]}
            onMediaUpdate={handleMediaUpdate}
          />
          <CustomDialog
            buttonText={"delete"}
            buttonColor="error"
            bodyContent={`Are you sure you want to delete this "${answer.text[lang]}"? This action will also remove any associated translations.`}
            onSubmit={() => deleteAnswer(qIndex, answer.id)}
          />
        </>
      )}
    </Box>
  );
}

/// drag drop answer is formatted differently than the answer component , the answers are objects with text  lang key then a a and b  key with the value  that  represent the matching pair
export function DragDropAnswer({
  qIndex,
  aIndex,
  answer,
  editState,
  handleInputChange,
  handleMediaUpdate,
  deleteAnswer,
  externalBookId,
  lang,
}) {
  return (
    <Box
      display="flex"
      gap="15px"
      alignItems="center"
      justifyContent="space-evenly"
      mb={1}
    >
      {/* <FormControl component="fieldset" mt sx={{ mx: 0.5 }}>
        <FormControlLabel
          control={
            <Checkbox
              color="success"
              checked={answer.isCorrect}
              onChange={(e) =>
                handleInputChange(qIndex, aIndex, e.target.checked, "isCorrect")
              }
              disabled={!editState[`${qIndex}-null`]}
            />
          }
          label={answer.isCorrect ? "Correct" : "Incorrect"}
          labelPlacement="top"
        />
      </FormControl> */}

      <TextField
        fullWidth
        variant="outlined"
        value={answer.text.a[lang] || ""}
        onChange={(e) => handleInputChange(qIndex, aIndex, e.target.value, "a")}
        disabled={!editState[`${qIndex}-null`]}
        style={{ marginRight: 10 }}
      />
      <TextField
        fullWidth
        variant="outlined"
        value={answer.text.b[lang] || ""}
        onChange={(e) => handleInputChange(qIndex, aIndex, e.target.value, "b")}
        disabled={!editState[`${qIndex}-null`]}
        style={{ marginRight: 10 }}
      />

      {editState[`${qIndex}-null`] && (
        <>
          <DialogPopup
            bookId={externalBookId}
            questionIndex={qIndex}
            answerIndex={aIndex}
            disabled={!editState[`${qIndex}-null`]}
            media={answer?.media?.filter((m) => m.language === lang)[0]}
            onMediaUpdate={handleMediaUpdate}
          />
          <CustomDialog
            buttonText={"delete"}
            buttonColor="error"
            bodyContent={`Are you sure you want to delete this "${answer.text[lang]}"? This action will also remove any associated translations.`}
            onSubmit={() => deleteAnswer(qIndex, answer.id)}
          />
        </>
      )}
    </Box>
  );
}
